import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DeleteConfirmModal } from '../../components/generic/DeleteConfirmModal';
import { createModal } from '../../components/generic/Modal';
import { useDeleteParticipantDocumentMutation } from '../../graphql/hooks/useDeleteParticipantDocumentMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantDocumentId: string;
  participantDocumentName: string;
}

export const ParticipantDocumentDeleteModal = createModal<Props>((props) => {
  const { participantId, participantDocumentId, participantDocumentName, modal } = props;

  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantDocumentMutation();
  const navigate = useNavigate();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantDocumentId,
      })
      .then(async () => {
        successToast('Document deleted successfully');
        await navigate(`/organizations/${organization.id}/participants/${participantId}/documents`);
      })
      .catch((err) => {
        errorToast(`Error deleting document: ${err.message}`);
      });
  }, [
    mutation,
    organization.id,
    participantId,
    participantDocumentId,
    successToast,
    navigate,
    errorToast,
  ]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this document?'
      confirmation={{
        level: 'Level3',
        confirm: participantDocumentName,
        acknowledgement:
          'I understand that this document and all of its associated data will be permanently deleted.',
      }}
      isLoading={mutation.isLoading}
      onDelete={onDelete}
    />
  );
});
